import { companyFactory } from '@rtls/core/models/location/company.factory';
import { locationFactory } from '@rtls/core/models/location/location.factory';
import { tagAttachmentFactory } from '@rtls/core/models/tag/tag-attachment.factory';
import { stepFactory } from '@rtls/core/models/thing/step.factory';
import { Thing } from '@rtls/core/models/thing/thing.model';
import {
	nullable,
	randomDate,
	randomEmptyList,
	randomName,
	randomNumber,
	randomPoint,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';
import { thingTypeFactory } from './thing-type.factory';

export const thingFactory = Factory.makeFactory<Thing>({
	id: Factory.each((i) => nullable(i)),
	createdDate: Factory.each(() => nullable(randomDate())),
	updatedDate: Factory.each(() => nullable(randomDate())),
	deletedDate: Factory.each(() => nullable(randomDate(), 3)),

	latestActivityDate: Factory.each(() => nullable(randomDate())),
	latestPositionDate: Factory.each(() => nullable(randomDate())),
	latestLocation: Factory.each(() => nullable(locationFactory.build())),
	latestPosition: Factory.each(() => nullable(randomPoint())),
	latestDataSource: Factory.each(() => 'IOT'),
	ownerLocation: Factory.each(() => locationFactory.build()),
	ownerCompany: Factory.each(() => companyFactory.build()),
	name: Factory.each(() => randomName()),
	types: Factory.each(() => [thingTypeFactory.build()]),
	volume: Factory.each(() => randomNumber()),
	tagAttachment: Factory.each(() => tagAttachmentFactory.build()),
	latestSteps: Factory.each(() => randomEmptyList(() => stepFactory.build())),
	lastOperationalStateEvent: '21/01/2024 15:43',
	operationalState: 'AVAILABLE',
});
